import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  gql,
} from "@apollo/client";

const client = new ApolloClient({
  //uri: "http://203.236.139.3:15151/",
  uri: "http://www.fontbada.co.kr:15151/",
  cache: new InMemoryCache(),
});

export default client;
